import React, { useEffect } from "react";
import { ExternalLink } from "lucide-react";

const GOOGLE_REVIEW_URL = "https://g.page/r/CTPVB8lPZngLEBM/review";

// Simple redirect page: /review -> Google review link (opens in same tab).
const ReviewRedirect = () => {
  useEffect(() => {
    window.location.replace(GOOGLE_REVIEW_URL);
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 pt-24">
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-[#efe4e5] mb-6">
        <ExternalLink size={26} className="text-[#6f5f62]" />
      </span>
      <h1 className="section-title text-2xl md:text-3xl text-[#3a3736] mb-3">
        Redirecting to Google Reviews
      </h1>
      <p className="font-serif-el text-lg text-[#4a4644] mb-6">
        Taking you to leave a review for Roger Minner Homes&hellip;
      </p>
      <a
        href={GOOGLE_REVIEW_URL}
        className="btn-mauve inline-flex items-center gap-2 px-8 py-4 rounded-sm"
      >
        Click here if you are not redirected <ExternalLink size={15} />
      </a>
    </div>
  );
};

export default ReviewRedirect;
